import { Role } from '@src/domain/rbac/entities/role.entity';
import type { RoleDTO } from '../dto/role.dto';

/**
 * Role Mapper
 * Converts between Role domain entity and RoleDTO
 */
export class RoleMapper {
    /**
     * Convert DTO to Domain Entity
     */
    static toDomain(dto: RoleDTO): Role {
        return Role.create({
            roleId: dto.role_id,
            name: dto.name,
            description: dto.description,
            isActive: dto.is_active,
            permissions: dto.permissions || [],
            createdAt: new Date(dto.created_at),
            updatedAt: new Date(dto.updated_at),
        });
    }

    /**
     * Convert Domain Entity to DTO
     */
    static toDTO(role: Role): RoleDTO {
        const props = role.toJSON();
        return {
            role_id: props.roleId,
            name: props.name,
            display_name: role.displayName, // Use the formatted display name
            description: props.description,
            is_active: props.isActive,
            permissions: props.permissions,
            created_at: props.createdAt.toISOString(),
            updated_at: props.updatedAt.toISOString(),
        };
    }

    /**
     * Convert array of DTOs to Domain Entities
     */
    static toDomainList(dtos: RoleDTO[]): Role[] {
        return dtos.map(dto => this.toDomain(dto));
    }

    /**
     * Convert array of Domain Entities to DTOs
     */
    static toDTOList(roles: Role[]): RoleDTO[] {
        return roles.map(role => this.toDTO(role));
    }
}
